import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Card, CardBody, CardFooter, CardHeader, Col, Container, Row } from 'reactstrap';
import { getPageTypeList } from '../../../slices/thunks';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';

import CoverPage from "../../../assets/images/report/thumbnail/CoverPage.png";
import TitleGraphTextPage from "../../../assets/images/report/thumbnail/TitleGraphTextPage.png";
import TitleTextGraphPage from "../../../assets/images/report/thumbnail/TitleTextGraphPage.png";
import TitleGraphPage from "../../../assets/images/report/thumbnail/TitleGraphPage.png";
import TitleGraphGraphPage from "../../../assets/images/report/thumbnail/TitleGraphGraphPage.png";

const imageMap = {
    'CoverPage.png': CoverPage,
    'TitleGraphTextPage.png': TitleGraphTextPage,
    'TitleTextGraphPage.png': TitleTextGraphPage,
    'TitleGraphPage.png': TitleGraphPage,
    'TitleGraphGraphPage.png': TitleGraphGraphPage,
};

const PageTypeList = () => {
    const dispatch = useDispatch();

    const pageState = state => state.Screen;
    const pageProperties = createSelector(pageState, state => ({
        types: state.pageTypeList,
        isLoadingList: state.isLoadingList,
    }));

    const { types, isLoadingList } = useSelector(pageProperties);

    useEffect(() => {
        dispatch(getPageTypeList());
    }, [dispatch]);

    const breadcrumbLinks = [
        { to: '#', label: 'Inicio' },
        { to: '#', label: 'Finanza' },
        { to: '#', label: 'Construir Reporte' },
    ];

    return (
        <React.Fragment>
            <UiContent />
            <div className='page-content'>
                <Container fluid>
                    <BreadCrumb title='Tipos de Pantallas' links={breadcrumbLinks} />

                    <Row>
                        {types.map((type, index) => (
                            <Col md={2} key={index}>
                                <Card className='card-height-100'>
                                    <CardHeader className="p-2 align-items-center d-flex">
                                        <h5 className="card-title mb-0 flex-grow-1">{type.name}</h5>
                                    </CardHeader>
                                    <CardBody className='text-center'>
                                        <img
                                            src={imageMap[type.thumbnail_image]}
                                            className="me-3"
                                            alt={type.name}
                                            style={{ width: '80%' }}
                                        />
                                    </CardBody>
                                    <CardFooter>
                                        {type.description}
                                    </CardFooter>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default PageTypeList;
